module.exports = __webpack_public_path__ + "static/img/IMG-20151019-WA0002.d31f44c7.jpg";